import faqContent from "../../../docs/faq.md?raw";

export const HOST_FAQ_CONTENT: string = faqContent;
